import {
    CREATE_ORDER,
    FETCH_ORDERS, SET_EXTENDED_ORDER,
    SET_ORDER_ID,
    SET_ORDER_LINK, SET_ORDER_PAGINATION_DATA,
    SET_RENT_END_DATE, SET_RENT_END_TIME,
    SET_RENT_START_DATE, SET_RENT_START_TIME,
} from "./types";

const initialState = {
    extendedOrder: [],
    paginationData: {
        total_pages: 1,
        next: '',
        previous: ''
    },
    orderId: null,
    orderLink: null,
    rentStartDate: null,
    rentEndDate: null,
    rentStartTime: null,
    rentEndTime: null,
    orderLoader: false,
    orders: []
}

export const ordersReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ORDERS:
            return {...state, orders: action.payload.reverse()}
        case CREATE_ORDER:
            return {...state}
        case SET_ORDER_PAGINATION_DATA:
            return {...state, paginationData: {
                    total_pages: action.payload.total_pages,
                    next: action.payload.next,
                    previous: action.payload.previous
                }}
        case SET_ORDER_ID:
            return {...state, orderId: action.payload}
        case SET_ORDER_LINK:
            return {...state, orderLink: action.payload}
        case SET_RENT_START_DATE:
            return {...state, rentStartDate: action.payload}
        case SET_RENT_END_DATE:
            return {...state, rentEndDate: action.payload}
        case SET_RENT_START_TIME:
            return {...state, rentStartTime: action.payload}
        case SET_RENT_END_TIME:
            return {...state, rentEndTime: action.payload}
        case SET_EXTENDED_ORDER: {
            return {...state, extendedOrder: action.payload}
        }
        default: return state
    }
}